import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import CosUsageList from 'ui-forms-components/usageList/CosUsageList';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_WIDTH = 540;
const PageListDialog = ({
  formName,
  pages,
  onCloseClick
}) => /*#__PURE__*/_jsxs(Modal, {
  "data-test-id": "page-list-dialog",
  width: MODAL_WIDTH,
  onEsc: onCloseClick,
  children: [/*#__PURE__*/_jsx(DialogCloseButton, {
    onClick: onCloseClick
  }), /*#__PURE__*/_jsx(DialogHeader, {
    children: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.frameworkTable.columns.appearsOn.pageList.header"
      })
    })
  }), /*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "dashboard.frameworkTable.columns.appearsOn.pageList.description",
      options: {
        count: pages.length,
        formName
      }
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(CosUsageList, {
      pages: pages
    })]
  })]
});
export default PageListDialog;